import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, OnInit, Optional, Output, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { ControlContainer, FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { WalletSelectList } from '@app/shared/models';
import { TcCurrencyPipe } from '@app/shared/pipes';
import { TranslateModule } from '@ngx-translate/core';
import { TableLoadingComponent } from '../table-loading/table-loading.component';

@Component({
    selector: 'tc-select-wallet',
    imports: [
        CommonModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        TcCurrencyPipe,
        ReactiveFormsModule,
        TranslateModule,
        TableLoadingComponent
    ],
    templateUrl: './select-wallet.component.html',
    styleUrls: ['./select-wallet.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class SelectWalletComponent implements OnInit, OnChanges {
    @Output() selectedItemEmit = new EventEmitter<any>();
    @Input() wallets: WalletSelectList[];
    @Input() selectedWalletId: string;
    @Input() formControlName: string;
    @Input() isLoading: boolean;
    @Input() hint: string;

    walletControl = new FormControl('');
    selected;
    // boolean
    showList: boolean;

    constructor(
        @Optional() private controlContainer: ControlContainer,
    ) {

    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.selectedWalletId) {
            this.findAndSetSelectedItem();
        }
    }

    ngOnInit(): void {
        this.findAndSetSelectedItem()
    }

    selectItem(item: any): void {
        this.selected = item;
        this.selectedItemEmit.emit(item)
        this.controlContainer.control.patchValue({ [this.formControlName]: item.walletId });
        this.walletControl.patchValue(item.walletName);
    }

    findAndSetSelectedItem(): any {
        if (this.selectedWalletId) {
            const selectedIndex = this.wallets.findIndex(a => a.walletId == this.selectedWalletId);
            this.selectItem(this.wallets[selectedIndex]);
        }
        else if (this.wallets && this.wallets.length > 0) {
            this.selectItem(this.wallets[0]);
        }
    }


    toggle(): void {
        this.showList = !this.showList;
    }

    hideList(e): void {
        this.showList = false;
    }


}
